import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";

export default function CopyTimelineDialog(props) {
    function handleCancel() {
        props.onClose(false);
    }

    function handleConfirm() {
        props.onClose(true);
    }

    return (
        <Dialog
            onClose={handleCancel}
            open={props.open}
            fullWidth
            maxWidth="sm"
            aria-labelledby="copy-timeline-dialog-title"
            slotProps={{
                paper: {
                    sx: { borderRadius: 3, overflow: "hidden" },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        color: "primary.main",
                        backgroundColor: "rgba(0, 149, 61, 0.09)",
                    }}
                >
                    <ContentCopyOutlinedIcon />
                </Box>
                <Box>
                    <Typography
                        id="copy-timeline-dialog-title"
                        variant="h5"
                        component="h2"
                        sx={{ lineHeight: 1.15 }}
                    >
                        {props.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                    >
                        Shared timelines must be copied before you can make
                        changes.
                    </Typography>
                </Box>
            </Box>

            <DialogContent
                dividers
                sx={{
                    p: { xs: 2, sm: 3 },
                    backgroundColor: "background.default",
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        borderRadius: 2.5,
                        border: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.paper",
                    }}
                >
                    <Typography variant="body1">{props.message}</Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
                <Button onClick={handleCancel} color="inherit">
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disableElevation
                >
                    Create own copy
                </Button>
            </DialogActions>
        </Dialog>
    );
}
